import TemplateView from '../../../TemplateView'
import CircleSpinner from '../../../components/spinner/CircleSpinner'
import {DemoDataStageType} from '../constants'
import messageResource from '../../../messageResource'
import UnhideableMoire from '../../../UnhideableMoire'

export default class DemoDataComponent extends TemplateView {

    constructor() {
        super()
        this.welcomeScreenBoxId = "welcomeScreenBoxId"

        this.state = {
            stage: DemoDataStageType.IDLE,
        }

        this.onStatePropertyChanged('stage', stage => this.refreshStage(stage))
    }

    refreshStage(stage) {
        if (stage !== DemoDataStageType.ACTIVE) {
            clearTimeout(this.progressTimer)
        }

        this.actualProgress = stage === DemoDataStageType.COMPLETED ? 100 : 0

        if (stage === DemoDataStageType.ACTIVE) {
            this.startDemoLoadingProgress()
        } else {
            this.renderProgress()
        }
    }

    startDemoLoadingProgress() {
        const baseTimeOut = 200
        const baseStep = 2
        const increaseProgress = () => {
            this.renderProgress()
            // increase percent value from 0 to 95
            if (this.actualProgress < 95)
            {
                this.actualProgress += Math.round(baseStep + Math.random() * baseStep);
                this.progressTimer = setTimeout(increaseProgress, baseTimeOut + Math.random() * baseTimeOut);
            }
        };
        increaseProgress();
    }

    templateHtml() {
        return `<div id='<%=welcomeScreenBoxId%>' class='welcomeScreenBox loadDemoDataState'>
                    <div class="loadDemoDataProgressContainer">
                        <div class='circleSpinnerContainer'/>
                        <div class='loadDemoDataProgressPercents'/>
                        <div class='loadDemoDataLabel'><%=label%></div>
                    </div>
                </div>`
    }

    templateModel() {
        return {
            welcomeScreenBoxId: this.welcomeScreenBoxId,
            label: messageResource.getMessage('welcome_screen.load_demo_data.label'),
        }
    }

    renderProgress() {
        this.percentsPlaceholder.text(this.actualProgress + '%')
    }

    show() {
        super.show()
        this.welcomeScreenBox.show()
    }

    hide() {
        super.hide()
        this.welcomeScreenBox.hide()
    }

    afterRender() {
        this.welcomeScreenBox = new UnhideableMoire(this.welcomeScreenBoxId, 'whiteMoireDiv')

        new CircleSpinner({
            additionalClassContainer: 'welcomeScreenSpinner',
        }).init(this.find('.circleSpinnerContainer'))
        this.actualProgress = 0
        this.percentsPlaceholder = this.find('.loadDemoDataProgressPercents')
        this.renderProgress()
    }
}


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/components/DemoDataComponent.js